import StreamingMLDiagnostics from "./StreamingMLDiagnostics";

export default StreamingMLDiagnostics;
